export const BASE_URL = 'https://www.youtube.com/';
export const WATCH_URL = `${BASE_URL}watch?`;
export const CONTINUATION_URL = `${BASE_URL}youtubei/v1/next?key=AIzaSyAO_FJ2SlqU8Q4STEHLGCilw_Y9_11qcW8`;
